{
	"noDirectoryAvailableAtThe": "No directory available at the location you chose. Please try again.",
	"noDirectorySelectedPleaseTry": "No directory selected. Please try again.",
	"weNeedPermissionToAccess": "We need permission to access your folder. Please try again.",
	"yourFolderIsNotAccessible": "Your folder is not accessible. Please make sure the folder is not locked and you have Read & Write permissions."
}
